import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2eu7jxi2: FaireBrandEntity = {
  token: "b_2eu7jxi2",
  type: "brand",
  name: "Peppercorn Kids",
  avatarUrl:
    "https://cdn.faire.com/fastly/5b1d94109fd019ab4679d3400e1a4ab2cc4a42310947887978a36077ba910dc3.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/4f876551a6b8f27251e750280d3b4b71201f03848f07d61cfbf2e2f968ac8cf0.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/5b1d94109fd019ab4679d3400e1a4ab2cc4a42310947887978a36077ba910dc3.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4f876551a6b8f27251e750280d3b4b71201f03848f07d61cfbf2e2f968ac8cf0.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 11,
  isTopShop: true,
  isInsider: true,
  description:
    "We are Peppercorn Kids- children's accessory brand. We put our heart at things we love most. Our line is playful and colorful. We are first committed to top quality and then-to fun, imagination and play. \n\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:03.422Z",
    importedBy: "entity-db-cli",
  },
};
